import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface AcceptOfferResponse {
  data: null
  meta: {
    message: string
    errors: string[]
  }
}

export function acceptOfferAction(requisitionId: string): Promise<ApiResponse<AcceptOfferResponse>> {
  return api.put<ApiResponse<AcceptOfferResponse>>(`/offers/${requisitionId}/accept`)
}
